
export class LeaveGenericDataModel {
    bajaId: number;
    nombre: string;
    apellidos: string;
    puestoUrgente: string;
    jornada?: any;
    absentista: string;
    nivel1: string;
    nivel2: string;
    nivel3: string;
    nivel4: string;
    nivel5: string;
    sexo: string;
    fnacimiento?: any;
    ffinContrato?: any;
    fantiguedad?: any;
    puesto: string;
    atributo1: string;
    atributo2: string;
    atributo3: string;
    atributo4: string;
    atributo5: string;
    atributo6: string;
    atributo7: string;
    atributo8: string;
    atributo9: string;
    atributo10: string;
    atributo11: string;
    atributo12: string;
    bradford?: number;
    tipo: string;
    falta?: any;
    fcierre?: any;
    fbaja?: any;
    noVisitar: string;
    recaida: string;
    acumuladoRecaida?: number;
    agudo: string;
    cronico: string;
    cirujia: string;
    embarazada: string;
    justificada: string;
    actitud: string;
    riesgosPsicosociales: string;
    avisoBaja?: any;
    avisoAlta?: any;
    codDiagnostico: string;
    leaveRef?: string; 
    diagnostico: string;
    fpa?: any;
    age?: number;
    seniority?: number;
    tipoDiagnostico: string;
    estimatedDuration?: number;
    tareaModelList: any;
    actuacionModelList: any;

    nivelArray: any = [];
    seniorityText: string;
    attributeArray: any = [];
    leaveDaysArray: any = [];
    reciadaDayArray: any = [];
}
